// Simple authentication helper hook.
// Provides a convenient way to read/write the auth token in localStorage
// and keep it in React state if the app ever needs to react to changes.

import { useState, useEffect } from 'react';

// Hook to use inside components when they care about the token value.
export function useAuth() {
  const [token, setToken] = useState(() => {
    const tokenData = localStorage.getItem('token');
    if (!tokenData) return null;
    if (tokenData.startsWith('{') || tokenData.startsWith('[')) {
      try {
        const parsed = JSON.parse(tokenData);
        return parsed.token || tokenData;
      } catch (e) {
        return tokenData;
      }
    }
    return tokenData;
  });

  // whenever the token state changes, reflect it in localStorage
  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }, [token]);

  const saveToken = (newToken) => {
    setToken(newToken);
  };

  const clearToken = () => {
    setToken(null);
  };

  return { token, saveToken, clearToken };
}

// Utility function that can be called outside of React (e.g. in helpers)
export function getToken() {
  const tokenData = localStorage.getItem('token');
  if (!tokenData) return null;
  if (tokenData.startsWith('{') || tokenData.startsWith('[')) {
    try {
      const parsed = JSON.parse(tokenData);
      return parsed.token || tokenData;
    } catch (e) {
      return tokenData;
    }
  }
  return tokenData;
}
